export const SAVE_PLAYER = "SAVE_PLAYER";
export const SAVE_PLAYER_COMPLETE = "SAVE_PLAYER_COMPLETE";
export const DELETE_PLAYER_COMPLETE = "DELETE_PLAYER_COMPLETE";
export const DELETE_PLAYERS_COMPLETE = "DELETE_PLAYERS_COMPLETE";
export const INIT_PLAYERS = "INIT_PLAYERS";
export const INIT_PLAYERS_COMPLETE = "INIT_PLAYERS_COMPLETE";
export const IMPORT_PLAYERS = "IMPORT_PLAYERS";
export const IMPORT_PLAYERS_COMPLETE = "IMPORT_PLAYERS_COMPLETE";
export const SAVE_IMPORT_PLAYERS = "SAVE_IMPORT_PLAYERS";
export const SAVE_IMPORT_PLAYERS_COMPLETE = "SAVE_IMPORT_PLAYERS_COMPLETE";
export const CANCEL_IMPORT_PLAYERS_COMPLETE = "CANCEL_IMPORT_PLAYERS_COMPLETE";
export const PARSE_CSV = "PARSE_CSV";
export const GENERATE_HEADERS = "GENERATE_HEADERS";
export const SET_VIEW = "SET_VIEW";
export const DELETE_IMPORT_PLAYERS = "DELETE_IMPORT_PLAYERS";
